import { mx } from "@springcare/dsm";
export var borderWidths = mx.borderWidths;
